import type { TypedDocumentNode } from '@urql/core';

import { gql } from '@/shared/types/gql';

import type { EnpsMutationData, EnpsSlotVars, SubmitEnpsVars } from '../types';

export const ENPS_MARK_SHOWN: TypedDocumentNode<EnpsMutationData<'markShown'>, EnpsSlotVars> = gql`
  mutation EnpsMarkShown($input: EnpsSurveySlotInput!) {
    investbanq {
      enps {
        markShown(input: $input) {
          status
          errors {
            message
            type
          }
          item {
            id
            outcome
          }
        }
      }
    }
  }
`;

export const ENPS_SUBMIT: TypedDocumentNode<EnpsMutationData<'submit'>, SubmitEnpsVars> = gql`
  mutation EnpsSubmit($input: SubmitEnpsInput!) {
    investbanq {
      enps {
        submit(input: $input) {
          status
          errors {
            message
            type
          }
          item {
            id
            outcome
          }
        }
      }
    }
  }
`;

export const ENPS_DISMISS: TypedDocumentNode<EnpsMutationData<'dismiss'>, EnpsSlotVars> = gql`
  mutation EnpsDismiss($input: EnpsSurveySlotInput!) {
    investbanq {
      enps {
        dismiss(input: $input) {
          status
          errors {
            message
            type
          }
          item {
            id
            outcome
          }
        }
      }
    }
  }
`;
